import React from "react";
import "./spinner.css"; // Asegúrate de tener el archivo CSS importado en tu proyecto

const Spinner = () => {
    return (
        <div className="loader-container">
            <div className="loader">
                <div className="loader-circle"></div>
            </div>
        </div>
    );
};

export default Spinner;
